import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import Layout from './components/Layout';

function MainApp() {
  const [darkMode, setDarkMode] = useState(false);

  // Load dark mode preference from localStorage
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode !== null) {
      setDarkMode(JSON.parse(savedDarkMode));
    }
  }, []);

  // Save dark mode preference to localStorage
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  return (
    <Routes>
      <Route path="/" element={<App darkMode={darkMode} setDarkMode={setDarkMode} />} />
      <Route path="/about" element={
        <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
          <About />
        </Layout>
      } />
      <Route path="/contact" element={
        <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
          <Contact />
        </Layout>
      } />
      <Route path="/privacy" element={
        <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
          <Privacy />
        </Layout>
      } />
      <Route path="/terms" element={
        <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
          <Terms />
        </Layout>
      } />
      <Route path="/disclaimer" element={
        <Layout darkMode={darkMode} setDarkMode={setDarkMode}>
          <Disclaimer />
        </Layout>
      } />
    </Routes>
  );
}

export default MainApp;
